import classNames from "classnames";
import type { ReactNode } from "react";
import React from "react";
import type { BsPrefixProps, BsPrefixRefForwardingComponent } from "react-bootstrap/esm/helpers";
import { useBootstrapPrefix } from "./ThemeProvider";

export interface BmBadgeProps extends BsPrefixProps, React.HTMLAttributes<HTMLElement> {
	append?: ReactNode;
	prepend?: ReactNode;
	prependAdditionalClasses?: string;
	size?: "sm" | "md" | "lg";
}

export const BmBadge: BsPrefixRefForwardingComponent<"span", BmBadgeProps> = React.forwardRef<
	HTMLElement,
	BmBadgeProps
>(
	(
		{
			as: Component = "span",
			bsPrefix,
			className,
			append,
			prepend,
			size,
			prependAdditionalClasses,
			children,
			...props
		},
		ref,
	) => {
		bsPrefix = useBootstrapPrefix(bsPrefix, "ui3-badge");

		return (
			<Component ref={ref} className={classNames(className, size && `${bsPrefix}-${size}`, bsPrefix)} {...props}>
				{prepend && <span className={`${bsPrefix}-addon ${prependAdditionalClasses || ""}`}>{prepend}</span>}
				<span className={`${bsPrefix}-text`}>{children}</span>
				{append && <span className={`${bsPrefix}-addon`}>{append}</span>}
			</Component>
		);
	},
);
